import { render, staticRenderFns } from "./Texts_Edit.vue?vue&type=template&id=f0bd22fe&"
import script from "./Texts_Edit.vue?vue&type=script&lang=js&"
export * from "./Texts_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports